export default __webpack_public_path__ + "static/media/icon__13.aa98a63d.svg";